import React from "react";
import Navbar from "../Components/Navbar";
import DateHelpers from "../Helper/DateHelpers";
import AdminRegistrationCardList from "../Components/AdminRegistrationCardList";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Session from 'react-session-api';
import Footer from "../Components/Footer";
import '../Styles/RegistrationSearch.scss';
import { Helmet } from "react-helmet";
import EventReporting from "./EventReporting";

function RegistrationSearch() {

   const [queriedRegistrations, setQueriedRegistrations] = useState()
   const [searchSelection, setSearchSelection] = useState('')
   const [openEvents, setOpenEvents] = useState()
   const [camperCount, setCamperCount] = useState()
   const [maleCount, setMaleCount] = useState()
   const [femaleCount, setFemaleCount] = useState()
   const [archivedEvents, setArchivedEvents] = useState()
   const [selectedEvents, setSelectedEvents] = useState()
   const [transactionSearchCriteria, setTransactionSearchCriteria] = useState({
      eventName: 'All Open Events',
      registrationType: 'Individual',
   });
   const navigate = useNavigate()

   const getOpenEventsOnPageLoad = async () => {
      try {
         var eventStatus = true;
         const eventResponse = await fetch('/getallevents', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ eventStatus })
         })

         const events = await eventResponse.json();
         var selectedEvents = events.data;
         console.log("Here's open events", selectedEvents.eventInfo)
         var mappedEvents = selectedEvents.eventInfo.map((selectedEvent) => <option key={selectedEvent.camp_name} value={selectedEvent.event_id}>{selectedEvent.camp_name + ': ' + DateHelpers.getDisplayDate(selectedEvent.begin_date) + '-' + DateHelpers.getDisplayDate(selectedEvent.end_date)}</option>)
         setOpenEvents(mappedEvents)
      } catch (error) {
         console.log(error)
      }
   }

   const getArchivedEventsOnPageLoad = async () => {
      try {
         var eventStatus = false;
         const eventResponse = await fetch('/getallevents', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ eventStatus })
         })

         const events = await eventResponse.json();
         var selectedEvents = events.data;
         console.log("Here's archived events", selectedEvents.eventInfo)
         var mappedEvents = selectedEvents.eventInfo.map((selectedEvent) => <option key={selectedEvent.camp_name} value={selectedEvent.event_id}>{selectedEvent.camp_name + ': ' + DateHelpers.getDisplayDate(selectedEvent.begin_date) + '-' + DateHelpers.getDisplayDate(selectedEvent.end_date)}</option>)
         setArchivedEvents(mappedEvents)
         setSelectedEvents(mappedEvents)

      } catch (error) {
         console.log(error)
      }
   }


   const getTransactionsOnPageLoad = async () => {
      try {
         console.log("transaction search criteria", transactionSearchCriteria)

         // Get Transactions
         const defaultTransactions = await fetch('/getregistrations', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
               transactionSearchCriteria,
               searchSelection
            })
         })
         var response = await defaultTransactions.json()
         console.log("Here's default Transactions", response)
         setQueriedRegistrations(response.data.registrations)
         setCamperCount(response.data.counts[0].count)
         setMaleCount(response.data.maleCounts[0].count)
         setFemaleCount(response.data.femaleCounts[0].count)
      } catch (error) {

      }
   }

   const handleClick = () => {
      const registrations = queriedRegistrations
      console.log('registrations', registrations)
      navigate('/reporting', { state: registrations });
   };


   useEffect(() => {
      getArchivedEventsOnPageLoad()
      getOpenEventsOnPageLoad()
   }, [])

    useEffect(() => {
         getTransactionsOnPageLoad()
      }, [archivedEvents || openEvents])

   useEffect(() => {
      if(!transactionSearchCriteria.eventName){
         return
      }

      getTransactionsOnPageLoad()
   }, [transactionSearchCriteria.eventName]);

   return (
      <div className="RegistrationSearchBackground">
         <div className='RegistrationSearchForeground'>
            <div className="RegistrationSearchHeading">
               <div
                  className="RegistrationSearchInvisibleDiv">
               </div>
               <div className='RegistrationSearchHeadingText'>
                  View and Manage Campers
               </div>
               <div className="RegistrationSearchHeadingBackButton">

               </div>
            </div>

            <div className="RegistrationSearchSelectOptions">
               <div className="RegistrationSearchSearch">
                  <div className="RegistrationSearchSearchText">
                     <input
                        id='transactionSearch'
                        type='text'
                        value={searchSelection}
                        placeholder="Registration Name"
                        onChange={(event) => setSearchSelection(event.target.value)}
                     />
                  </div>
                  <div className="RegistrationSearchSearchButton">
                     <button onClick={(event) => getTransactionsOnPageLoad()}>
                        Search
                     </button>
                  </div>
               </div>

               <div className='RegistrationSearchDropdownOne'>
                  <select
                     value={transactionSearchCriteria.eventType}
                     onChange={(event) => setTransactionSearchCriteria({ ...transactionSearchCriteria, eventName: (event.target.value) })}
                  >
                     <option value="All Events">All Open Events</option>
                     {
                        openEvents
                     }
                  </select>

               </div>
               <div className='RegistrationSearchDropdownTwo'>

                  <select
                     value={transactionSearchCriteria.eventType}
                     onChange={(event) => setTransactionSearchCriteria({ ...transactionSearchCriteria, eventName: (event.target.value) })}
                  >
                     <option value="All Events">All Archived Events</option>
                     {
                        archivedEvents
                     }
                  </select>
               </div>
               <div className="RegistrationSearchReports">
                  <button onClick={handleClick}>
                     View Table
                  </button>
               </div>
            </div>
            <div className="RegistrationSearchCamperCount">
               <div className="RegistrationSearchTotalCount">
                  <div className="RegistrationSearchTotalCountHeading">
                     Total Count
                  </div>
                  <div className="RegistrationSearchTotalCountNumber">
                     {camperCount}
                  </div>
               </div>
               <div className="RegistrationSearchMaleCount">
                  <div className="RegistrationSearchMaleCountHeading">
                     Male Count
                  </div>
                  <div className="RegistrationSearchMaleCountNumber">
                     {maleCount}
                  </div>
               </div>
               <div className="RegistrationSearchFemaleCount">
                  <div className="RegistrationSearchFemaleCountHeading">
                     Female Count
                  </div>
                  <div className="RegistrationSearchFemaleCountNumber">
                     {femaleCount}
                  </div>
               </div>
            </div>
            <div className="RegistrationSearchRegistrations">
               <AdminRegistrationCardList
                  queriedRegistrations={queriedRegistrations} />
            </div>
         </div>
      </div>
   )
};

export default RegistrationSearch;
